import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="detail-toggler"
export default class extends Controller {
  static targets = ['checkbox', 'content', 'dateTime', 'timezone']

  connect = () => {
    if (this.hasDateTimeTarget) {
      this.checkboxTarget.checked = this.hasDateTimeData
    }
  }

  perform = (event) => {
    if (this.hasContentTarget) {
      const isChecked = event.target.checked

      if (isChecked) {
        this.setDefaultTimezone()
        this.contentTarget.classList.remove('grid-rows-[0fr]', 'opacity-0')
        this.contentTarget.classList.add('grid-rows-[1fr]', 'opacity-100', 'mt-4')
      }
      else {
        this.contentTarget.classList.remove('grid-rows-[1fr]', 'opacity-100', 'mt-4')
        this.contentTarget.classList.add('grid-rows-[0fr]', 'opacity-0')
      }

      // Clear fields if unchecked (only if targets exist)
      if (!isChecked) {
        if (this.hasDateTimeTarget) {
          this.dateTimeTarget.value = ''
        }
        if (this.hasTimezoneTarget) {
          this.timezoneTarget.value = ''
        }
      }
    }
  }

  setDefaultTimezone = () => {
    if (!this.hasTimezoneTarget) return
    if (this.timezoneTarget.value) return

    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone
    const match = Array.from(this.timezoneTarget.options).find(o => o.value === tz)
    if (match) match.selected = true
  }

  get hasDateTimeData() {
    return this.dateTimeTarget.value && this.dateTimeTarget.value.trim() !== ''
  }
}
